"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryOptions = exports.mapCountryToCountryOption = void 0;
const concat_1 = __importDefault(require("lodash/concat"));
const countries_constants_1 = require("./countries.constants");
function mapCountryToCountryOption(value) {
    if (!value) {
        return '';
    }
    const keys = Object.keys(countries_constants_1.CountryOption).filter(x => countries_constants_1.CountryOption[x] == value);
    return keys.length > 0 ? keys[0] : '';
}
exports.mapCountryToCountryOption = mapCountryToCountryOption;
function getCountryOptions(t, countries = Object.values(countries_constants_1.CountryOption), value) {
    const auxiliaryOptions = [
        {
            value: '',
            label: t(`forms:dropdown.pleaseSelect`),
        },
    ];
    if (value && !countries.includes(value)) {
        auxiliaryOptions.push({
            value,
            label: t(`forms:country.options.${value.toLowerCase()}`),
            disabled: true,
        });
    }
    return (0, concat_1.default)(auxiliaryOptions, countries.map(code => ({
        value: code,
        label: t(`forms:country.options.${code.toLowerCase()}`),
    })));
}
exports.getCountryOptions = getCountryOptions;
//# sourceMappingURL=countries.utils.js.map